export const isAgeEligible = (age, eligibleAge = 18) => {
  return age >= eligibleAge;
};
